import { render, staticRenderFns } from "./AwesomeIcon.vue?vue&type=template&id=bb42d406&"
import script from "./AwesomeIcon.vue?vue&type=script&lang=js&"
export * from "./AwesomeIcon.vue?vue&type=script&lang=js&"
import style0 from "./AwesomeIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports